export enum ProductSearchType {
    All,
    WithCategory,
    WithoutCategory,
}
